



















import { MDAUserService } from '@/api/com/MetaPattern/APP/MDA/User/MDAUserService';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { WorkScope } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScope';
import { WorkScopeService } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScopeService';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { Diagram } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Diagram';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';
import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
  components: {
  }
})
export default class LoginInit extends Vue {
  private percentage = 0;

  constructor() {
    super();
    this.percentage = 0;
  }

  init() {
    this.$store.dispatch('ModuleMD/clearAction');
    // 初始化完成后自动跳转到/
    const promiseAll = [] as unknown[];
    // 加载系统数据
    promiseAll.push(WorkScopeService.LoadAllAsync());
    promiseAll.push(MDExtendService.GetAPPTreeAsync(''));
    promiseAll.push(MDExtendService.GetInfrastructureAPPTreeAsync());
    Promise.all(promiseAll).then((result: unknown[]) => {
      const workScopes = result[0] as Array<WorkScope>;
      const apps = result[1] as Array<APP>;
      const infrastructureAPP = result[2] as APP;
      workScopes.forEach((element: WorkScope) => {
        element.persistenceStatus = EnumPersistenceStatus.None;
      });
      apps.forEach(app => {
        if (ValidateHelper.IsNotNullOrEmpty(app.workScope_ID)) {
          app.workScope = workScopes.find((item: WorkScope) => item.id === app.workScope_ID);
          app.persistenceStatus = EnumPersistenceStatus.None;
        }
      });
      if (ValidateHelper.IsNotNullOrEmpty(infrastructureAPP.workScope_ID)) {
        const workScope = workScopes.find((item: WorkScope) => item.id === infrastructureAPP.workScope_ID);
        if (workScope) {
          infrastructureAPP.workScope = workScope;
        }
      }
      this.$store.dispatch('ModuleMD/setWorkScopesAction', workScopes);
      this.$store.dispatch('ModuleMD/setAppsAction', apps);
      this.$store.dispatch('ModuleMD/setAppsAction', [infrastructureAPP]);
      this.percentage += 60;
      this.loadInfrastructures(infrastructureAPP);
    });
  }

  mounted() {
    MDAUserService.UserIsInitAsync()
      .then(res => {
        if (!res) {
          this.$router.push('/UserInit');
        } else {
          this.init();
        }
      })
      .catch(err => {
        console.log(err);
        this.$message({ type: 'error', message: `初始化失败!原因是：${err}，请刷新重试` });
      });
  }

  /** 加载Infrastructure内部的组件详情 */
  private loadInfrastructures(app: APP) {
    if (app) {
      const promiseAll = [] as unknown[];
      app.aPPComponents.forEach(appComponent => {
        promiseAll.push(Diagram.loadAsync(appComponent.designId, appComponent.componentType));
      });
      app.bEComponents.forEach(beComponent => {
        promiseAll.push(Diagram.loadAsync(beComponent.designId, beComponent.componentType));
      });
      app.uIModelComponents.forEach(uiModelComponent => {
        promiseAll.push(MDExtendService.GetFullComponentAsync(uiModelComponent.designId, uiModelComponent.componentType));
      });
      Promise.all(promiseAll).then((result: unknown[]) => {
        result.forEach(item => {
          if (item instanceof Diagram) {
            this.$store.dispatch('ModuleMD/setDiagramAction', item);
          } else if (item instanceof UIModelComponent) {
            this.$store.dispatch('ModuleMD/setUIModelComponentAction', item);
          }
        });
        this.percentage += 40;
      });
    } else {
      this.percentage += 40;
    }
  }

  @Watch('percentage')
  checkFinish() {
    if (this.percentage >= 100) {
      this.$store.dispatch('User/setInitDoneAction', true);
      this.$router.push('/');
    }
  }

  get customColors() {
    return [
      { color: '#f56c6c', percentage: 20 },
      { color: '#e6a23c', percentage: 40 },
      { color: '#5cb87a', percentage: 60 },
      { color: '#1989fa', percentage: 80 },
      { color: '#6f7ad3', percentage: 100 }
    ];
  }
}
